/// <reference path="../../typings/tsd.d.ts" />
module warsApp.services {
    

    export class ManageSystemCodesService extends services.DataService<Wars.Domain.Model.Codes.CodeGroup> {
        

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public createNewSystemCode(codeGroup: Wars.Domain.Model.Codes.CodeGroup, isSystemLevel: boolean): Wars.Domain.Model.Codes.SystemCode {
            var systemCode = this.createNewEntity<Wars.Domain.Model.Codes.SystemCode>("SystemCode");
            systemCode.myParentCodeGroup = codeGroup;
            systemCode.isSystemLevel = isSystemLevel;
            systemCode.uniqueIdentifier = UtilityService.generateGuidComb();
            return systemCode;
        }

        public createNewSpecializedCodeGroup(): Wars.Domain.Model.Codes.CodeGroup {
            var codeGroup = this.createNewEntity<Wars.Domain.Model.Codes.CodeGroup>("CodeGroup");
            codeGroup.isDocumentTypeCodeGroup = false;
            return codeGroup;
        }

        public getAllCodesForProcessConfiguration(id: string): ng.IPromise<Wars.Domain.Model.Codes.CodeGroup[]> {
            const query = this.breezeModule.EntityQuery
                .from("CodeGroups")
                .where("processConfiguration_id", "==", id)
                .expand("codes");

            return this.executeQuery(query);
        }

        public getCodeGroup(id: string): ng.IPromise<Wars.Domain.Model.Codes.CodeGroup> {
            const query = this.breezeModule.EntityQuery
                .from("CodeGroups")
                .where("id", "==", id)
                .expand("codes");

            return this.fetch(query);
        }
    }
}

warsApp.registerService('ManageSystemCodesService', ['breeze', '$q']);